"use strinct";

const $ = require("jquery");

function handleFormInputState() {
  const enabled = $("#invoice_address_differs").is(":checked");
  if (enabled) {
    $(".js-account-invoice-form").collapse("show");
  } else {
    $(".js-account-invoice-form").collapse("hide");
  }
}

function onLoad() {
  $(".js-account-submit").on("click", function(e) {
    e.stopPropagation();
    e.preventDefault();

    if (!$("#invoice_address_differs").is(":checked")) {
      $(".js-account-invoice-form input[type=text]").val("");
      $(".js-account-invoice-form select").val("");
    }

    $(".js-account-details-form").submit();
  });

  $("#invoice_address_differs").on("change", handleFormInputState);

  handleFormInputState();
}

module.exports = {
  onLoad
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-account/booking-account.js